





import React from "react";
import './Main.css'


function MySkills(){
    return(
        <>
     <section id="skills" className="skills margin-top">
        <h2>My Skills</h2>
            <div className="grid margin-top">
                <div className="boxSkill">
                    <h3 >Front End</h3>
                    <div className="felx margin">
                       <p>HTML5</p>
                       <div className="percentile">
                         <div className="percentileresult eighty">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                       <p>CSS3</p>
                       <div className="percentile felx">
                         <div className="percentileresult seventyfive">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                       <p>JavaScript</p>
                       <div className="percentile">
                         <div className="percentileresult seventyfive">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                       <p>React.js</p>
                       <div className="percentile">
                         <div className="percentileresult eighty">

                         </div>
                       </div>
                    </div>
                   
                    
                </div>
                <div className="boxSkill"> 
                    <h3>Back End</h3>
                    <div className="felx margin">
                       <p>Node.js </p>
                       <div className="percentile">
                         <div className="percentileresult seventyfive">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                       <p>Express.js</p>
                       <div className="percentile">
                         <div className="percentileresult seventyfive">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                       <p>Python</p>
                       <div className="percentile">
                         <div className="percentileresult seventy">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                       <p>MySQL</p>
                       <div className="percentile">
                         <div className="percentileresult eighty">

                         </div>
                       </div>
                    </div>
                
                </div>
                <div className="boxSkill">
                    <h3>Tools</h3>
                    <div className="felx margin">
                    <p> Git & GitHub</p>
                       <div className="percentile">
                         <div className="percentileresult seventyfive">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                    <p>  Visual Studio Code</p>
                       <div className="percentile">
                         <div className="percentileresult eighty">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                       <p>Responsive Design</p>
                       <div className="percentile">
                         <div className="percentileresult seventyfive">

                         </div>
                       </div>
                    </div>
                    
                </div>
                <div className="boxSkill">
                    <h3>Soft Skills</h3>
                    <div className="felx margin">
                    <p>Problem-solving </p>
                       <div className="percentile">
                         <div className="percentileresult eightyfive">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                    <p>Collabration</p> 
                       <div className="percentile">
                         <div className="percentileresult eighty">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                    <p>Attention to Deatail </p>
                       <div className="percentile">
                         <div className="percentileresult eighty">

                         </div>
                       </div>
                    </div>
                    <div className="felx margin">
                    <p>  Fast Learner</p>
                    
                       <div className="percentile">
                         <div className="percentileresult eightyfive">

                         </div>
                       </div>
                    </div>
                    
                      
                    
                </div>
            </div>
     </section>
        </>
    )
}
export default MySkills